webpackJsonp([190008816670350],{

/***/ 914:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0011_bloom.jpg","type":"Minor Spell","subtype":"Buff","cost":2,"ATK":null,"HP":null,"rules_text_1":"Put a +1/+1 rune on a friendly unit or hero that doesn't have a +1/+1 rune.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Bloom","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"Bigger is better, and slightly bigger is slightly better.","color":"Neutral","spec":null,"bottom":"Magic","rulings":[],"keywords":[],"slug":"bloom"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"bloom","keywords":[],"imageRegex":"/bloom.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-bloom-610e34ca4a97fd76cb67.js